import { render, staticRenderFns } from "./Fixedmode.vue?vue&type=template&id=1f958b64&scoped=true&"
import script from "./Fixedmode.vue?vue&type=script&lang=ts&"
export * from "./Fixedmode.vue?vue&type=script&lang=ts&"
import style0 from "./Fixedmode.vue?vue&type=style&index=0&id=1f958b64&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f958b64",
  null
  
)

export default component.exports